<template>
  <div class="regular-header">
     <navbar />

   <headerGrid>
      <div class="font-size-custom-max-48"><h1 id="font-calc-culture">Onze cultuur</h1></div>
      <p>Precies maar zeker niet rechtlijnig, dat omschrijft Folded Paper. Plannen stellen we samen op, we behalen ze samen, voeren ze samen uit en we vieren ze samen. Wij nemen de regie maar doen dit alleen vanuit onze eigen vakkennis. <br><br> In tegenstelling tot wat onze naam doet vermoeden werken wij digital first. Maar om alles digitaal perfect te krijgen heb je toch een vel papier nodig. Wij bieden het lege canvas en samen bouwen we aan de mooiste branding en producten die bij je ambitie passen.</p>
      <a v-scroll-to="'#usp-section'"><img src="../assets/Folded_Paper_asset_arrow_down.png"></a>
   </headerGrid>

   <uspSection id="usp-section"></uspSection>

  <div class="container">
   <div class="culture-picture">
    <img src="../assets/Folded_Paper_test_foto.png" v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
   </div>
  </div>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid odd">
      <div class="img-box">
        <img src="../assets/Folded_Paper_team.jpg">
      </div>
      <div class="text-box">
        <div class="content padding-left">
          <h3>Ons flexibele team</h3>
          <p>Teams zijn heilig bij ons. Met wie we samenwerken en in welke samenstelling bepaalt in onze ogen een groot deel van het eindresultaat. Wij werken al jaren samen met vaste klanten, partners en freelancers. Hier doen wij ook niet geheimzinnig over. Experts zijn heilig! Een team is dus een stukje Folded Paper en een stukje...</p>
        </div>
      </div>
    </div>
  </oddEvenGrid>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid even">
      <div class="text-box">
        <div class="content padding-right">
          <h3>Eindhoven</h3>
          <p>Velen zien Amsterdam als het middelpunt van design, maar Eindhoven wordt niet voor niks de Lichtstad genoemd. Wij zitten graag dicht bij het vuur. Dit betekent niet alleen een nauwe samenwerking met de klant, maar ook het op de voet volgen van alle ontwikkelingen in het levendige Strijp-S; dit is dé plek waar tech en design samenkomen.</p>
        </div>
      </div>
      <div class="img-box">
        <img class="float-right" src="../assets/Folded_Paper_Eindhoven.jpg">
      </div>
    </div>
  </oddEvenGrid>

    <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}">  
    <div class="odd-even-grid odd">
      <div class="img-box">
        <img src="../assets/Folded_Paper_impact.jpg">
      </div>
      <div class="text-box">
        <div class="content padding-left">
          <h3>Impact</h3>
          <p>Wij hebben projecten gedaan voor hogescholen, stichtingen, advocaten, zorgverzekeraars, training academies, bekende nederlanders en radio stations. Zo hebben wij al twee jaar een samenwerking met een start-up die bij een grote organisatie (Eindhovens Dagblad/BN de stem) pilots draait met hun product. Hierdoor hebben wij ervaring met het werken voor organisaties die landelijk impact hebben.</p>
        </div>
      </div>
    </div>
  </oddEvenGrid>

    <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid even">
      <div class="text-box">
        <div class="content padding-right">
          <h3>Klantprofiel</h3>
          <p>Onze ideale klant geeft meer om de wereld dan om zichzelf. Onderwijs is hier een goed voorbeeld van omdat 
            altijd gedacht wordt aan het collectief.
            Ons team bestaat eigenlijk alleen uit "zuiderlingen". Wij werken graag voor organisaties die een "Brabantse 
            mentaliteit" hebben of hier voor open staan. </p>
        </div>
      </div>
      <div class="img-box">
        <img class="float-right" src="../assets/Folded_Paper_client.jpg">
      </div>
    </div>
  </oddEvenGrid>


<div class="container">
  <div class="netflix-list" v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="img-box">
      <img src="../assets/Folded_Paper_Netflix_lijst.jpg">
    </div>
    <div class="text-box">
      <div class="content">
        <img src="../assets/Folded_Paper_Netflix_logo.jpg">
        <h4>Oh ja en over ons...</h4>
        <p>Bij Folded Paper houden we van het ‘supernatural / sci-fi’ verhaal, en deze serie houdt momenteel onze avonden en kantooruren in bedwang.</p>
      
      <scissorsButton>
        <router-link to="/netflix" class="button"><p>Gaaf, tell me more!</p></router-link>
      </scissorsButton>
      </div>
    </div>
  </div>
</div>
<footerComponent></footerComponent>
</div>

</template>

<script>
import headerGrid from '@/components/generalLayout/headerGrid.vue';
import uspSection from '@/components/specificLayout/uspSection.vue';
import oddEvenGrid from '@/components/generalLayout/oddEvenGrid.vue';
import scissorsButton from '@/components/generalLayout/scissorsButton.vue';
import navbar from '@/components/generalLayout/navbar.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';

export default {
  name: 'cultuur',

  components:{
    headerGrid,
    uspSection,
    oddEvenGrid,
    scissorsButton,
    navbar,
    footerComponent
  },
}
</script>

<style lang="scss" scoped>


.culture-picture{
  img{
    margin: 0 auto;
    display: block;
    width: 100%;
    margin-top: layout-val-64(-1);
  }
}

.netflix-list{
  display: flex;
  max-width: 690px;
  margin: 0 auto;
  margin-top: layout-val-8(4);

  .img-box, .text-box{
    flex:1;
  }

  img{
    max-height: 320px;
  }
  
  a{
    text-decoration: none;
    p{
      font-weight: 900;
    }
  }

  .text-box{
    position: relative;
      .content{
        @include pos-center($axis: 'y');
      }
  }

  .button{
    margin: 0;
    margin-top: 0;
    p{
      margin: 0;
    }
  }
}

@media screen and (max-width: 640px) {
  .netflix-list{
    flex-direction: column-reverse;
    margin-top:layout-val-64(1);

    h4,p{
      text-align: center;
    }
    h4{
      padding-top: layout-val-8(2);
    }
    
    .button{
      margin: 0 auto;
      display: block;
      max-width: 200px;
    }

    img{
      margin: 0 auto;
      margin-top: layout-val-8(4);
      display: block;
      max-height: 250px;
    }
  }
  .netflix-list .text-box .content{
    position: relative;
    top:0;
    transform: none;
  }
}
</style>
